export default {"src":"/_next/static/media/in_network_atms.253f4a1e.svg","height":386,"width":486};